import * as Registry from "./registry.js";
/**
 * Enables normalizations that enforce schema constraints and recover from unsupported cases.
 */
export function withListsSchema(schema) {
  return function (editor) {
    Registry.register(editor, schema);
    return editor;
  };
}